// extracted by mini-css-extract-plugin
export var accordionItem = "styles-module--accordionItem--6Twnx";
export var browserIe = "styles-module--browser-ie--hSz+P";
export var closed = "styles-module--closed--MB71Y";
export var buttonClosed = "styles-module--buttonClosed--P4Aq+";